import { client } from './client'
import type { Branding } from '@/stores/branding'

export interface PublicSettings {
  login_enabled: boolean
  registration_enabled: boolean
  sso_enabled: boolean
  sso_authorize_url: string
  sso_button_label: string
  sso_prompt_text: string
  /** 品牌与外观配置，后端保证完整下发（未配置时给默认值） */
  branding?: Branding
}

export interface LoginResult {
  access_token: string
  refresh_token: string
  user: { id: string; username: string; display_name?: string; email: string; role: 'admin' | 'tenant_admin' | 'user'; tenant_id: string; created_at: string }
}

export const authApi = {
  // 登录标识是 email（2026-07-30 起 username 退役为显示字段，不再是凭据）。
  login: async (data: { email: string; password: string }) => {
    const res = await client.post('/auth/login', data)
    return res.data as LoginResult
  },
  refresh: async (refreshToken: string) => {
    const res = await client.post('/auth/refresh', { refresh_token: refreshToken })
    return res.data as { access_token: string; refresh_token: string }
  },
  ssoCallback: async (token: string) => {
    const res = await client.post('/auth/sso/callback', { token })
    return res.data as LoginResult
  },
  getPublicSettings: async () => {
    const res = await client.get('/settings/public')
    return res.data as PublicSettings
  },
}
